/**
 * words-happen-gql's POST endpoint, on the API's origin (apiOrigin), that /reset-password asks which providers the
 * account behind a password reset link signs in with.
 */
export const RESET_PROVIDERS_PATH = '/auth/reset-providers';

/**
 * In ResetProvidersResponse.providers: the account has a password. Never there for an account that only signs in with
 * an email link, which Identity Platform also lists as provider "password".
 */
export const PASSWORD_PROVIDER_ID = 'password';

/** The body of POST RESET_PROVIDERS_PATH. */
export interface ResetProvidersRequest {
  /** The reset link's oobCode. It is checked, never used up. */
  oobCode: string;
}

/** A 200 from POST RESET_PROVIDERS_PATH. */
export interface ResetProvidersResponse {
  /**
   * Identity Platform provider IDs, e.g. ["google.com"] or ["google.com", "password"]: the account's social providers,
   * and PASSWORD_PROVIDER_ID when it has a password. Nothing else about the account.
   */
  providers: string[];
}

/**
 * The body of every refusal: an invalid, expired or used oobCode (400) and a rate-limited request (429) alike, so a
 * refusal says nothing about the code or the account.
 */
export interface ResetProvidersRefusal {
  errorCode: 'RESET_PROVIDERS_REFUSED';
}

export const RESET_PROVIDERS_REFUSAL: ResetProvidersRefusal = { errorCode: 'RESET_PROVIDERS_REFUSED' };

/** The endpoint's URL on `apiOrigin`, e.g. https://api.wordshappen.dev/auth/reset-providers. */
export const resetProvidersUrl = (apiOrigin: string): string => new URL(RESET_PROVIDERS_PATH, apiOrigin).href;
